var map = {
	"./de.json": "db06",
	"./en.json": "d782",
	"./es-ES.json": "1891",
	"./fr.json": "ff8f",
	"./hi.json": "4a23",
	"./id.json": "ecd5",
	"./it.json": "8092",
	"./ja.json": "7687",
	"./ko.json": "898c",
	"./nl.json": "2a86",
	"./pt-PT.json": "c80a",
	"./tr.json": "111b",
	"./zh-CN.json": "1dc8",
	"./zh-TW.json": "d95c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f4f4";